module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-red-9b68c63f50e0584ec966f01c984db774.svg";